import React from 'react';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Header from '../../shared/modal/header';
import Body from './tooltip-modal-components/tooltip-modal-body';
import { PopUpModalStyles } from '../../shared/modal/styles';
import useFundStateStore from '../common/fund-state-hook';

const PopUpModal = styled(Modal)`
  ${PopUpModalStyles};
`;

export default function TooltipModal() {
  const set = useFundStateStore(state => state.set);
  const show = useFundStateStore(state => state.showTooltip);
  const title = useFundStateStore(state => state.tooltipTitle);
  const content = useFundStateStore(state => state.tooltipContent);

  const handleHide = () => {
    set(state => {
      state.showTooltip = false;
    });
  };

  return (
    <PopUpModal
      show={show}
      centered="true"
      dialogAs="article"
      dialogClassName="horizontal"
      onHide={handleHide}
      className={show ? 'show' : 'hide'}
    >
      <Header closeButton />
      <Body title={title} content={content} />
    </PopUpModal>
  );
}
